import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Panel } from "./common";

const pct = (v) => (v == null ? "—" : `${v}%`);

export const IssuerProfile = ({ name }) => {
  const [p, setP] = useState(null);
  useEffect(() => { setP(null); api.get(`/banks/${encodeURIComponent(name)}/profile`).then((r) => setP(r.data)); }, [name]);
  if (!p) return null;
  return (
    <Panel title={`Dynamic issuer profile · ${name}`} className="mt-6" testid="issuer-profile">
      <div className="grid md:grid-cols-4 gap-6">
        <div>
          <p className="label-xs">Resolved / win</p><p className="font-mono text-2xl font-extrabold text-brand mt-1">{pct(p.win_rate)}</p>
          <p className="font-mono text-[10px] text-white/40">{p.resolved} resolved disputes</p>
          <p className="label-xs mt-4">Preferred channel</p><p className="text-sm mt-1">{p.channel}</p><p className="text-xs text-white/45">{p.timing}</p>
          <p className="label-xs mt-4">Evidence this issuer rewards</p><p className="font-mono text-xs text-accent2 mt-1" data-testid="issuer-rewards">{p.rewards.join(" · ") || "not enough data yet"}</p>
        </div>
        <div>
          <p className="label-xs mb-2">Win rate by reason code</p>
          {p.by_reason.map((x) => <div key={x.reason} className="flex justify-between font-mono text-[11px] py-1 border-b border-white/5"><span className="text-white/60">{x.label}</span><span>{pct(x.win_rate)} <span className="text-white/30">n{x.n}</span></span></div>)}
        </div>
        <div>
          <p className="label-xs mb-2">Evidence lift (win with vs without)</p>
          {p.evidence_lift.slice(0, 7).map((x) => (
            <div key={x.evidence} className="font-mono text-[10px] py-1">
              <div className="flex justify-between"><span className="text-white/60">{x.evidence}</span><span style={{ color: x.lift > 0 ? "#CCFF00" : x.lift < 0 ? "#F87171" : "#888" }}>{x.lift > 0 ? "+" : ""}{x.lift}pt</span></div>
            </div>
          ))}
          {p.evidence_lift.length === 0 && <p className="text-xs text-white/35">Needs more resolved disputes.</p>}
        </div>
        <div>
          <p className="label-xs mb-2">Seasonal bias</p>
          {p.seasonal.map((x) => (
            <div key={x.quarter} className="flex items-center gap-2 font-mono text-[10px] py-1">
              <span className="w-6 text-white/60">{x.quarter}</span>
              <div className="flex-1 h-1.5 bg-white/5"><div className="h-full bg-[#FF2BD6]" style={{ width: `${x.win_rate || 0}%` }} /></div>
              <span className="w-12 text-right">{pct(x.win_rate)}</span>
            </div>
          ))}
        </div>
      </div>
    </Panel>
  );
};
